export default __webpack_public_path__ + "static/media/loader.53588580.gif";